import React from "react";
import { useUser } from "../../AuthContext";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import Grid from "@mui/material/Grid2";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import ChangePassword from "./ChangePassword";

const Profile = () => {
    const [open, setOpen] = React.useState(false);
    const { user, isPaidUser, subscriptionId, clientId } = useUser();
    return (
      <Box sx={{ width: '100%', maxWidth: { sm: '100%', md: '1700px' } }}>
        <Typography component="h2" variant="h6" sx={{ mb: 1 }}>
          Profile
        </Typography>
        <Divider sx={{ mb: (theme) => theme.spacing(3) }}/>
        <Grid
            container
            spacing={2}
            columns={12}
            sx={{ mb: (theme) => theme.spacing(2) }}
        >
            <Box display="flex" gap={5} alignItems="center">
                <FormControl
                    sx={{
                        minWidth: "350px", // Set a reasonable minimum width
                        width: `${user.email.length * 10}px`, // Adjust based on email length
                        maxWidth: "100%", // Prevent it from exceeding the container
                    }}
                >
                    <FormLabel htmlFor="name">Name</FormLabel>
                    <TextField
                    id="name"
                    type="text"
                    name="name"
                    value={user["full_name"]}
                    variant="outlined"
                    fullWidth
                    disabled
                    />
                </FormControl>
                <FormControl
                    sx={{
                        minWidth: "350px", // Set a reasonable minimum width
                        width: `${user.email.length * 10}px`, // Adjust based on email length
                        maxWidth: "100%", // Prevent it from exceeding the container
                    }}
                >
                    <FormLabel htmlFor="email">Email</FormLabel>
                    <TextField
                    id="email"
                    type="email"
                    name="email"
                    value={user.email}
                    variant="outlined"
                    fullWidth
                    disabled
                    />
                </FormControl>
            </Box>
            
        </Grid>
        <Box sx={{ mb: (theme) => theme.spacing(2) }} >
            {!("iss" in user) &&
            <Button variant="outlined" color="error" size="small" onClick={() => setOpen(true)}>
                Reset Password
            </Button>
            }
            {("iss" in user && user["iss"] == "https://accounts.google.com") &&
                <Typography variant="body1" sx={{ color: 'text.secondary' }}>
                Account Created Using <b>Google</b>
                </Typography>
            }
        </Box>
        <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Current Plan: <b>{isPaidUser ? "Pro" : "Free"}</b>
        </Typography>
        {/* <Typography component="h2" variant="h6" sx={{ mb: 1 }}>
          Billing
        </Typography>
        <Divider sx={{ mb: (theme) => theme.spacing(3) }}/>
        <Grid
            container
            spacing={2}
            columns={12}
            sx={{ mb: (theme) => theme.spacing(2) }}
        >
            <Pricing />
        </Grid> */}
        <ChangePassword open={open} handleClose={() => setOpen(false)} />
      </Box>
    )
};

export default Profile;
